import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { BrowserRouter } from 'react-router-dom';
import { LoaderModal } from './Components/_helpers/LoaderModal';
// import './assets/fontawesome-5-pro-master/css/all.css';
// import './assets/scss/mdb-pro.scss'
// import App from './App';
//import '@fortawesome/fontawesome-free/css/all.min.css';
//import 'bootstrap-css-only/css/bootstrap.min.css';
//import 'mdbreact/dist/css/mdb.css';
import reportWebVitals from './reportWebVitals';
import Routes from './Routes';

ReactDOM.render(
  <BrowserRouter>
    <Routes />
    <LoaderModal loading={true}></LoaderModal>
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();